import API from "./API";

export const sendQRcodesByEmail = async (data: FormData) => {
  return await API.post("/cms/email/student-login-details-old", data);
};
